//
//
//
//
//

export default {
	props: {
		iconClass: {
			type: String,
			required: true
		}
	},
	computed: {
		iconName () {
			return `#icon-${this.iconClass}`
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/IconSvg.vue